import { Component, Input, ViewEncapsulation } from '@angular/core';

export interface ITimelineEvent {
    title: string;
    subtitle: string;
    complete?: boolean;
}
/**
 * @group Data Visualization
 * @component Timeline
 *
 * @export
 * @class LsqTimelineComponent
 */
@Component({
    selector: 'lsq-timeline',
    template: `
        <div class="timeline-component">
            <div *ngFor="let event of events; let i = index">
                <div
                    *ngIf="i !== events.length - 1"
                    class="timeline-segment"
                    [ngClass]="{ 'is-complete': events[i + 1]?.complete }"
                    [style.width.%]="100 / (events.length - 1)"
                    [style.left.%]="(i / (events.length - 1)) * 100"
                ></div>
                <popover-content
                    parentClass="bs-popover-top"
                    [style.left.%]="(i / (events.length - 1)) * 100"
                >
                    <h4>{{ event.title }}</h4>
                    <p>{{ event.subtitle }}</p>
                </popover-content>
                <div
                    class="timeline-dot"
                    [ngClass]="{ 'is-complete': event.complete }"
                    [style.left.%]="(i / (events.length - 1)) * 100"
                ></div>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-timeline.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqTimelineComponent {
    @Input() public events: ITimelineEvent[];
}
